import React, { FunctionComponent } from "react"
import { iFeatured, iFeaturedQuery } from "../../definitions/Featured"
import { Column, RowInfo } from "react-table-6"
// import "react-table-6/react-table.css"
import Table from "../../components/Table/Table"
import { useHistory } from "react-router"
import Seo from "../../components/Seo/Seo"
import { useData } from "../../hooks/useData"

const columns: Column[] = [
  {
    Header: "Collection",
    accessor: "dataType",
  },
  {
    id: "position",
    Header: "Position",
    accessor: "position",
  },
  {
    id: "data",
    Header: "Count",
    accessor: (d) => (d.data || []).length,
    filterable: false,
    sortable: false,
  },
]

const defaultSorted = [
  {
    id: "position",
    desc: false,
  },
]

const Featured: FunctionComponent = () => {
  const { total } = useData<iFeaturedQuery, iFeatured>({
    link: "/v1/featured",
    defaultQuery: {},
    shouldPushQuery: true,
  })
  const history = useHistory()

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const onClick = (rowInfo: RowInfo) => {
    const { original } = rowInfo

    history.push("/featured/" + original._id)
  }

  return (
    <>
      <Seo title="Featured | Dashboard | VR-All-Art" />
      <div className="content">
        <div className="content-header">
          <h1 className="text-center">Featured ({total})</h1>
        </div>
      </div>
      <div className="grid-wrap">
        <Table<iFeaturedQuery, iFeatured>
          link="/v1/featured"
          columns={columns}
          defaultSorted={defaultSorted}
          onClick={onClick}
        />
      </div>
    </>
  )
}

export default Featured
